import {Link} from 'react-router-dom'
import HeadVideo from '../videos/HomeVideo.mp4'

const MainHeader = () => {
  return (
    <header className="main__header">

      <div className="container">
      <div>
        <video muted autoPlay loop>
          <source src={HeadVideo} type="video/mp4"/>
        </video>
      </div>
        <div className='main__header-container'>

        <div className="main__header-left">
          
          <h1>MadMonk Is A Design Company.</h1>
          <p>
          That Creates Innovative Spatial Experiences By Integrating Content And Digital Media Technology.
          </p>
          {/* <Link to="/about" className='btn lg'>WHO WE ARE</Link> */}
        </div>
        <div className="main__header-right">
          {/* <div className="main__header-circle"></div>
          <div className="main__header-image">
            <img src={Image} alt="Main Header Image" />
          </div> */}
          </div>
        </div>
      </div>
    </header>
  )
}

export default MainHeader